import { Moon, Sun, Monitor } from 'lucide-react'
import { useTheme } from '../../contexts/ThemeContext'
import Button from '../ui/Button'

export default function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme()
  
  const themes = [
    { value: 'light' as const, label: 'Light', icon: Sun },
    { value: 'dark' as const, label: 'Dark', icon: Moon },
    { value: 'system' as const, label: 'System', icon: Monitor }
  ]
  
  const currentTheme = themes.find(t => t.value === theme)
  const Icon = currentTheme?.icon || Sun
  
  const handleThemeChange = () => {
    const currentIndex = themes.findIndex(t => t.value === theme)
    const nextIndex = (currentIndex + 1) % themes.length
    setTheme(themes[nextIndex].value)
  }
  
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="sm"
        icon={Icon}
        onClick={handleThemeChange}
        aria-label={`Switch theme. Current: ${theme}. Click to cycle to next theme.`}
        title={`Current: ${theme}. Click to cycle themes.`}
      >
        <span className="hidden sm:inline">
          {currentTheme?.label}
        </span>
      </Button>
      
      <div className="hidden md:flex items-center gap-1">
        {themes.map(({ value, label, icon: ThemeIcon }) => (
          <button
            key={value}
            onClick={() => setTheme(value)}
            className={`p-2 rounded-lg transition-theme ${
              theme === value
                ? 'bg-primary text-white'
                : 'hover:bg-surface'
            }`}
            aria-label={`Switch to ${label} theme`}
            title={`Switch to ${label} theme`}
          >
            <ThemeIcon className="w-4 h-4" />
          </button>
        ))}
      </div>
      
      <div className="text-xs text-text-muted hidden lg:block">
        {resolvedTheme === 'dark' ? 'Dark mode' : 'Light mode'}
      </div>
    </div>
  )
}